import ERROR_MESSAGES from './errorMessages';

export const PERSONALIZED_FINANCING_TITLE = 'Personalized Financing Terms';
export const FINANCING_TITLE = 'Your Financing Terms';
export const CAPITAL_ONE_TITLE = 'Buy a car using Capital One pre-qualification';
export const CAPITAL_ONE_DESCRIPTION =
  'Experience a whole new way to buy a car from Carvana and Capital One';
export const PARTNER_LENDING_TITLE = 'Buy a car using your preferred lender';
export const PARTNER_LENDING_DESCRIPTION =
  'Buy a car from Carvana and finance with your preferred lender';
export const PARTNER_FINANCING_TITLE = (partnerLongName: string) => {
  return `Buy a car using ${partnerLongName} pre-qualification`;
};
export const PARTNER_FINANCING_DESCRIPTION = (partnerLongName: string) => {
  return `Experience a whole new way to buy a car from Carvana and ${partnerLongName}`;
};
export const LENDING_TREE_PARTNER_ID = 40;
export const CREDIT_KARMA_PARTNER_ID = 54;
export const CAPITAL_ONE_PARTNER_ID = 24;
export const DELTA_PARTNER_ID = 2;
export const CARVANA_PARTNER_ID = 1;
export const PARTNER_LENDING_ID = 72;
export const PARTNER_LOGO_ASSET_FOLDER = `${process.env.CARVANA_APP_ASSETS_BASE_URL}/partner-header-logos-assets`;

export { ERROR_MESSAGES };
